import * as Dialog from './Dialog.js'

export const Commands = {
  'Dialog.close': Dialog.close,
  'Dialog.handleClick': Dialog.handleClick,
  'Dialog.openFile': Dialog.openFile,
  'Dialog.openFolder': Dialog.openFolder,
  'Dialog.showAbout': Dialog.showAbout,
  'Dialog.showMessage': Dialog.showMessage,
}
